// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.price-text {
  display: flex;
  justify-content: right;
}

.one-line {
  white-space: nowrap;
}

.price-summary-container {
  background-color: var(--fds-color--white);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border-radius: 3.6px;
  min-width: 312px;
}

.price-summary-container .fmc-type--body1 {
  line-height: 28.8px;
}

.product-info-line-items {
  gap: 5px;
}

@media screen and (max-width: 1023px) {
  .price-summary-container .fmc-type--body1 {
    font-size: 16px;
    line-height: 24px;
  }
  .price-summary-container > h6 {
    margin-top: 11px;
    margin-bottom: 18px !important;
  }
}
@media screen and (max-width: 599px) {
  .price-summary-container {
    margin-top: 0 !important;
    padding: 13px !important;
    min-width: 200px;
  }
  .price-summary-container .fmc-type--body1 {
    font-size: 12px;
    line-height: 14px;
  }
  .price-summary-container > h6 {
    font-size: 14px;
    margin-bottom: 8px !important;
  }
  .price-summary-container .total-section {
    margin-top: 8px !important;
  }
  .price-summary-container .total-label,
  .price-summary-container .total-value {
    font-size: 14px;
  }
}
/* Triplication required to be specific enough to override FDS here. */
.itemized-taxes.itemized-taxes.itemized-taxes {
  color: var(--fds-color--gray2);
}

.itemized-taxes.itemized-taxes-label {
  padding-inline-start: 0.85rem;
}`, "",{"version":3,"sources":["webpack://./src/components/ProductInfo/ProductInfo.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,yCAAA;EACA,0CAAA;EACA,oBAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,QAAA;AACF;;AAEA;EACE;IACE,eAAA;IACA,iBAAA;EACF;EAEA;IACE,gBAAA;IACA,8BAAA;EAAF;AACF;AAGA;EACE;IACE,wBAAA;IACA,wBAAA;IACA,gBAAA;EADF;EAIA;IACE,eAAA;IACA,iBAAA;EAFF;EAKA;IACE,eAAA;IACA,6BAAA;EAHF;EAMA;IACE,0BAAA;EAJF;EAOA;;IAEE,eAAA;EALF;AACF;AAQA,sEAAA;AACA;EACE,8BAAA;AANF;;AASA;EACE,6BAAA;AANF","sourcesContent":[".price-text {\n  display: flex;\n  justify-content: right;\n}\n\n.one-line {\n  white-space: nowrap;\n}\n\n.price-summary-container {\n  background-color: var(--fds-color--white);\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);\n  border-radius: 3.6px;\n  min-width: 312px;\n}\n\n.price-summary-container .fmc-type--body1 {\n  line-height: 28.8px;\n}\n\n.product-info-line-items {\n  gap: 5px;\n}\n\n@media screen and (max-width: 1023px) {\n  .price-summary-container .fmc-type--body1 {\n    font-size: 16px;\n    line-height: 24px;\n  }\n\n  .price-summary-container > h6 {\n    margin-top: 11px;\n    margin-bottom: 18px !important;\n  }\n}\n\n@media screen and (max-width: 599px) {\n  .price-summary-container {\n    margin-top: 0 !important;\n    padding: 13px !important;\n    min-width: 200px;\n  }\n\n  .price-summary-container .fmc-type--body1 {\n    font-size: 12px;\n    line-height: 14px;\n  }\n\n  .price-summary-container > h6 {\n    font-size: 14px;\n    margin-bottom: 8px !important;\n  }\n\n  .price-summary-container .total-section {\n    margin-top: 8px !important;\n  }\n\n  .price-summary-container .total-label,\n  .price-summary-container .total-value {\n    font-size: 14px;\n  }\n}\n\n/* Triplication required to be specific enough to override FDS here. */\n.itemized-taxes.itemized-taxes.itemized-taxes {\n  color: var(--fds-color--gray2);\n}\n\n.itemized-taxes.itemized-taxes-label {\n  padding-inline-start: 0.85rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
